import React, { Fragment } from 'react'
import { func, string, bool, object } from 'prop-types'
import classnames from 'classnames'
import Icon from '../../ui/icon/Icon'
import SearchBar from '../../SearchBar'
import { getFilterLabel } from '../helpers'
import { ITEMS_WITHOUT_SEARCHBAR } from '../constants'
import { messages } from '../messages'

const HeaderView = ({ onClick = null, query, item, category, handleQuery, isAreaFilter, searchType }) => {
  const itemsWithoutSearchBar = ITEMS_WITHOUT_SEARCHBAR.includes(item)
  const searchBarSectionClasses = classnames(
    'ad-filter__searchbar',
    { 'ad-filter__searchbar--hidden': itemsWithoutSearchBar, 'ad-filter__searchbar--area-filter': isAreaFilter }
  )
  return (
    <Fragment>
      <section className={searchBarSectionClasses}>
        {!itemsWithoutSearchBar && <SearchBar
          query={query}
          placeholder={{ ...messages[getFilterLabel(item, searchType)] }}
          placeholderValue={{ ...category }}
          handleInput={e => handleQuery(e.target.value)}
        />}
        {onClick && <Icon svg='cancel' onClick={onClick} />}
      </section>
    </Fragment>
  )
}

HeaderView.propTypes = {
  onClick: func,
  handleQuery: func,
  query: string,
  item: string,
  searchType: string,
  isAreaFilter: bool,
  category: object
}

export default HeaderView